import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';

import Google from '../../../images/icons/google.svg?react';

function CustomGoogleLogin(props) {
  const login = useGoogleLogin({
    flow: 'auth-code',
    onSuccess: async (res) => {
      props.onLoginSuccess(res);
    },
  });

  return (
    <button onClick={() => login()} {...props} type='button' title='google'>
      <div>
        {props.loading ? (
          <div className='btn-spinner' />
        ) : (
          <Google width='30' height='30' fill='#fff' viewBox='0 0 30 30' className='bi bi-google' />
        )}
      </div>
      <span>SIGN IN WITH GOOGLE</span>
    </button>
  );
}

export default CustomGoogleLogin;

